import {HttpClientService} from "../../../services/httpClient/httpClientService";
import {EmailModel} from "../../../core/sharedmodels/email/EmailModel";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {TableAsync} from "../../../core/components/table/tableAsync";
import {StamdataEmailApi} from "../../../services/api/stamdataEmail/stamdataEmailApi";
import {SlideIn} from "../../../core/components/slideIn/slideIn";
import {dateTimeStringFromApiToDate} from "../../../index";
import {
    StamdataEmailTableColumnsPostModel
} from "../../../services/api/stamdataEmail/stamdataEmailTableColumnsPostModel";
import {stamdataEmailResponseModel} from "../../../services/api/stamdataEmail/stamdataEmailResponseModel";
import {AccountService} from "../../../services/account/accountService";
import {useState} from "react";
import {nameof} from "ts-simple-nameof";
import {ModalSize} from "../../../core/components/slideIn/modalSize";
import {EmailInfo} from "./emailInfo";

interface ReceivedMailsProps {
    userId: string;
}

const emailApi = new StamdataEmailApi(new HttpClientService(), new AccountService())

export const ReceivedMails = (props: ReceivedMailsProps) => {
    const [tableNumber, setTableNumber] = useState<number>(0);
    const [selectedMail, setSelectedMail] = useState<EmailModel>();

    const modalTarget = "email-view-modal";

    const clickedMail = (email: EmailModel) => {
        setSelectedMail(email);
    }

    const renderTable = () => {
        return <TableAsync key={tableNumber}
                           tableIdentifier={`receivedMailsTable`}
                           tableHeader={Localizer.profilepage_ReceivedEmails()}
                           renderTableHead={renderTableHead}
                           initOrder={[2, "desc"]}
                           asyncUrl={emailApi.emailDatalist()}
                           columns={emailTableColums()}
                           getCustomPostData={() => {return {userId: props.userId}}}
                           rowClickFunction = {(mail: EmailModel) => {clickedMail(mail)}}
                           showFilteredRecordsInfo
        />
    }

    const emailTableColums = (): DataTables.ColumnSettings[] => {
        let columns: DataTables.ColumnSettings[] = [];

        columns = columns.concat([
            {
                data: (data: stamdataEmailResponseModel) => data.subject,
            },
            {
                data: (data: stamdataEmailResponseModel) => data.fromName,
                orderable: false
            },
            {
                data: (data: stamdataEmailResponseModel) => data,
                render: (data: stamdataEmailResponseModel) => {
                    return `<div>${data.sentAt ? dateTimeStringFromApiToDate(data.sentAt).dateWithTimeFormat() : ""}</div>`;
                }
            }
        ]);

        return columns;
    }

    const renderTableHead = () => {
        return (
            <thead>
            <tr>
                <th data-column-name={nameof<StamdataEmailTableColumnsPostModel>(x => x.Subject)}
                    data-priority="1">
                    {Localizer.global_subject()}
                </th>
                <th data-column-name={nameof<StamdataEmailTableColumnsPostModel>(x => x.Sendby)}
                    data-priority="1">
                    {Localizer.createMail_SendBy()}
                </th>
                <th data-column-name={nameof<StamdataEmailTableColumnsPostModel>(x => x.SendAt)}
                    data-priority="1">
                    {Localizer.createMail_Send()}
                </th>
            </tr>
            </thead>
        );
    }

    return (
        <>
            {renderTable()}

            {selectedMail &&
                <SlideIn
                    key={tableNumber + 1}
                    id={modalTarget}
                    title={Localizer.global_email()}
                    actionText={Localizer.vejlederPage_creatingVejleder()}
                    actionOnCloseCallback={() => {setSelectedMail(undefined)}}
                    actionFinishedCallback={() => {
                        setTableNumber(tableNumber + 1);
                        setSelectedMail(undefined)
                    }}
                    defaultOpen={true}
                    bodyContent={<EmailInfo email={selectedMail}/>}
                    modalSize={ModalSize.md}
                />
            }
        </>


    );
}
